import React from 'react';
import { Dialog } from '@ygtechnologies/rubus-ui';
import { LoadingIndicator, DateTimeDisplay } from '@ygtechnologies/bygr-frontend-component-library';
import { useAsyncState } from '@/utils/hooks';
import { getOutgoingSms } from '@/services/communicore';
import { DetailList, SendAttemptsTable } from './shared';
import theme from './Communicore.module.scss';

interface OutgoingSmsDetailsModalProps {
    id: string;
    onClose(): void;
}

const OutgoingSmsDetailsModal: React.FC<OutgoingSmsDetailsModalProps> = ({ id, onClose }) => {
    const [sms] = useAsyncState(() => getOutgoingSms(id), [id], null);

    return (
        <Dialog open onOpenChange={(open) => !open && onClose()}>
            <Dialog.Content contentWidth="sm">
                <Dialog.Header>Outgoing SMS</Dialog.Header>
                {!sms ? (
                    <LoadingIndicator />
                ) : (
                    <div>
                        <DetailList
                            items={[
                                { label: 'Created', value: <DateTimeDisplay value={sms.createdAt} /> },
                                { label: 'To', value: sms.to },
                                { label: 'Status', value: sms.status },
                                {
                                    label: 'Sent',
                                    value: sms.sendTime && <DateTimeDisplay value={sms.sendTime} />,
                                },
                                { label: 'Attempts', value: `${sms.attemptCount} / ${sms.maxAttempts}` },
                            ]}
                        />

                        <h4 className={theme.sectionHeader}>Body</h4>
                        <p className={theme.smsBody}>{sms.body}</p>

                        <h4 className={theme.sectionHeader}>Send attempts</h4>
                        <SendAttemptsTable attempts={sms.sendAttempts} />
                    </div>
                )}
            </Dialog.Content>
        </Dialog>
    );
};

export default OutgoingSmsDetailsModal;
